jQuery(document).ready(function () {
    //Scrolls up and down with the user until the element reaches parent's floor/ceiling
    function scrollAlong(){
        var scrollMiddle = $(window).scrollTop() + ($(window).height() / 2);
        
        $('.scroll_along').each(function(){
            var parentTop = $(this).parent().offset().top;
            var parentBottom = $(this).parent().height() - $(this).height();
            var thisMiddle = scrollMiddle - parentTop - ($(this).outerHeight() / 2);

            var parentOffsetBottom = $(this).parent().height() + $(this).parent().offset().top - ($(this).outerHeight() / 2);

            var thePosition = 'fixed';
            var theTop = $(window).height() / 2 - ($(this).outerHeight() / 2);

            if(thisMiddle < 0){
                theTop = 0;
                thePosition = 'static';
            }

            if(scrollMiddle > parentOffsetBottom){
                theTop = parentBottom;
                thePosition = 'absolute';
            }
            
            $(this).css({position: thePosition, top: theTop});
        });
    }


    //Initiate functions that run on scroll, load and/or resize.
    $(window).on('scroll load resize',function(){
        scrollAlong();
    });


});
